// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__-VrZD","resendInfoText":"OnGoingPaymentBox_resendInfoText__YLi3O"};